module.exports = __webpack_public_path__ + "img/ott box 2 gb+16gb.8ad967ff.jpg";